import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import DatetimeFormat from '../../../../datetime/DatetimeFormat';

const DetailsView = ({details}) => (
  <div className="card">
    <div className="card-header">
      <div className="card-title">
        <Translate value="mandate.details.details.title"/>
      </div>
    </div>
    <h3>
      <Translate value="mandate.details.details.documentType"/>
    </h3>
    <div>
      {details.subtypeName}
    </div>
    <hr className="my-4"/>
    <h3>
      <Translate value="mandate.details.details.perimeter.label"/>
    </h3>
    <div>
      <Translate value={`mandate.details.details.perimeter.${details.scope}`}/>
    </div>
    <hr className="my-4"/>
    <h3>
      <Translate value="mandate.details.details.certifyingThirdParty"/>
    </h3>
    <div>
      {details.thirdPartyGroup ?
        <Translate value={`mandate.thirdPartyGroup.${details.thirdPartyGroup}`}/> :
        '-'
      }
    </div>
    <hr className="my-4"/>
    <h3>
      <Translate value="mandate.details.details.creationDate"/>
    </h3>
    <div>
      <DatetimeFormat
        value={details.creationDate}
        format="shortDate"
      />
    </div>
    <hr className="my-4"/>
    <h3>
      <Translate value="mandate.details.details.comment"/>
    </h3>
    <div>
      {details.comment}
    </div>
  </div>
);

DetailsView.propTypes = {
  details: PropTypes.object.isRequired
};

export default DetailsView;
